import { Layout } from 'antd';
import React from 'react';
import styles from './DashboardLayout.module.css';
import DashboardHeader from 'src/components/Header/DashboardHeader/DashboardHeader';
import classNames from 'classnames';
import Sidebar from './Sidebar';
// import useAuth from 'src/hooks/useAuth';

interface Props {
  children: React.ReactNode;
}

const DashboardLayout = (props: Props) => {
  const { children } = props;
  // const { isAuthenticated } = useAuth();

  return (
    <Layout className={styles.DashboardLayout}>
      <DashboardHeader />
      <Layout>
        <Sidebar />
        <Layout className={classNames(styles['DashboardLayout--RightCol'], 'bg-white')}>
          {children}
        </Layout>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
